import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initPixel } from "./utils/tracking";
import { captureAttribution } from "./utils/leadCapture";

// Tracking starts before React renders so PageView fires as early as possible.
captureAttribution();
initPixel();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-412" data-mp="2abnnyv1lspzg" />);
}